module.exports = __webpack_public_path__ + "static/media/orange-stamp-wave.3456f7b5.png";